// extracted by mini-css-extract-plugin
export default {"eventTitle":"Pane-module__eventTitle___L_j6A"};